import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HubConnection, HubConnectionBuilder, HttpTransportType, LogLevel } from '@microsoft/signalr';
import { Subject, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaymentHubInfo } from '../../interfaces/payment';

export interface ResultadoTerminal {
  sucesso: boolean;
  mensagem: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentHubService {
  private apiURL = environment.apiUrl + '/v' + environment.apiVersion;
  private connection: HubConnection | null = null;
  private resultado = new Subject<ResultadoTerminal>();

  readonly resultado$ = this.resultado.asObservable();

  constructor(private httpClient: HttpClient) {}

  async conectar(patientId: number): Promise<void> {
    await this.desconectar();

    const response = await firstValueFrom(
      this.httpClient.get<any>(`${this.apiURL}/Payment/hub`),
    );
    const info = response?.data?.[0] as PaymentHubInfo | undefined;
    if (!info?.url || !info?.token) throw new Error('Hub de pagamento indisponível.');

    this.connection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Warning)
      .withUrl(info.url, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: () => info.token,
      })
      .build();

    this.connection.on('NotifyCustomer', (raw: string) => {
      try {
        const payload = JSON.parse(raw) as { success?: boolean; response?: string; errors?: string[] };
        this.resultado.next({
          sucesso: !!payload.success,
          mensagem: payload.success
            ? (payload.response ?? 'Pagamento aprovado.')
            : (payload.errors ?? []).join(' ').trim() || 'Pagamento recusado.',
        });
      } catch {
        this.resultado.next({ sucesso: false, mensagem: 'Resposta do terminal ilegível.' });
      }
    });

    await this.connection.start();
    await this.connection.send('Login', String(patientId));
  }

  async desconectar(): Promise<void> {
    if (!this.connection) return;
    try {
      await this.connection.stop();
    } finally {
      this.connection = null;
    }
  }
}
